// @flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { ProductFiltersModal } from 'components/templates/productFiltersModal';
import { ProjectFiltersModal } from 'components/templates/projectFiltersModal';
import { UpcomingEventFiltersModal } from 'components/templates/upcomingEventsFilterModal';
import filterIcon from 'assets/images/filter.png';
import filterWhiteIcon from 'assets/images/filterWhite.png';
import { FiltersModal } from 'components/templates/filtersModal';
import { EventFiltersModal } from 'components/templates/eventsFiltersModal';
import { useViewport } from 'components/templates/viewportProvider';
import { ArchitectureDesignFilters } from 'components/templates/architecture&DesignFilters';
import { RentalFiltersModal } from 'components/templates/rentalsFiltersModal';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  filterType: string,
  className?: string,
  theme?: 'dark-theme' | 'light-theme',
  disabled?: boolean,
  filterClass?: string,
  activeFilters: Array<string>,
  filterContent: Component,
};

export const FilterButton = (props: Props) => {
  const {
    filterType,
    className = '',
    disabled = false,
    filterClass = '',
    theme = 'dark-theme',
    activeFilters = [],
    filterContent,
  } = props;
  const icon = theme === 'light-theme' ? filterIcon : filterWhiteIcon;
  const { isMobile } = useViewport();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Filters modal
  const onClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const buttonClassNames = classNames('filters-button', className, theme);
  const filterClassNames = classNames('active-filters', filterClass);

  const filtersDisplayName =
    activeFilters.length <= 2
      ? activeFilters.join(', ')
      : `${activeFilters.slice(0, 2).join(', ')} + ${activeFilters.length -
          2} more`;
  return (
    <>
      <button
        className={buttonClassNames}
        onClick={onClick}
        type={'button'}
        disabled={disabled}
      >
        <div className={'filters-icon-container'}>
          <img src={icon} alt="icon" />
        </div>
        {!isMobile ? (
          <>
            {activeFilters.length > 0 ? (
              <span className={filterClassNames}>{filtersDisplayName}</span>
            ) : (
              <span className={filterClassNames}>Refine Results</span>
            )}
            <span>Refine</span>
          </>
        ) : (
          ''
        )}
      </button>
      {filterType === 'projects' && (
        <ProjectFiltersModal isOpen={isModalOpen} onClosePress={closeModal} />
      )}
      {filterType === 'architecture-projects' && (
        <ArchitectureDesignFilters
          isOpen={isModalOpen}
          onClosePress={closeModal}
        />
      )}
      {filterType === 'rentals' && (
        <RentalFiltersModal isOpen={isModalOpen} onClosePress={closeModal} />
      )}
      {filterType === 'neighbourhood' && (
        <FiltersModal
          isOpen={isModalOpen}
          onClosePress={closeModal}
          filterContent={filterContent}
        />
      )}
      {filterType === 'products' && (
        <ProductFiltersModal isOpen={isModalOpen} onClosePress={closeModal} />
      )}
      {filterType === 'past-events' || filterType === 'past-events-mobile' ? (
        <EventFiltersModal isOpen={isModalOpen} onClosePress={closeModal} />
      ) : null}
      {filterType === 'upcoming-events-desktop' ||
      filterType === 'upcoming-events-filter-mobile' ? (
        <UpcomingEventFiltersModal
          isOpen={isModalOpen}
          onClosePress={closeModal}
        />
      ) : null}
    </>
  );
};
